import { Button } from '@/shared/ui/Button';
import { Icon } from '@/shared/ui/Icon';
import { usePushRegistration } from '@/features/push/usePushRegistration';

const PUSH_ENABLED =
  (import.meta as ImportMeta & { env?: Record<string, string> }).env?.VITE_PUSH_ENABLED === 'true';

/**
 * 마이 화면의 푸시 알림 설정 행.
 * default → 켜기 버튼, granted → 켜짐 표시, denied → 브라우저 설정 안내.
 * 미지원 환경(Safari 등)·기능 플래그 off 면 아예 렌더하지 않는다.
 */
export function PushNotificationCard() {
  const { permission, enablePush, isRegistering } = usePushRegistration();

  if (!PUSH_ENABLED || permission === 'unsupported') return null;

  const isGranted = permission === 'granted';
  const isDenied = permission === 'denied';

  return (
    <section aria-labelledby="profile-alert-heading" className="space-y-2">
      <h2 id="profile-alert-heading" className="px-0.5 text-[11px] font-semibold uppercase tracking-[0.04em] text-ink-muted">알림</h2>
      <div className="overflow-hidden rounded-[22px] border border-surface-border/70 bg-surface/60 backdrop-blur-sm" aria-label="푸시 알림 설정">
      <div className="flex items-center gap-3 px-3.5 py-3">
        <span className="flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[11px] bg-primary-soft text-primary">
          <Icon name="bell" size={17} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-[14px] font-semibold tracking-[-0.2px] text-ink">푸시 알림</span>
          <span className="mt-0.5 block truncate text-[11px] text-ink-muted">
            {isGranted
              ? '새 채팅과 모임 알림을 받아요.'
              : isDenied
                ? '브라우저 설정에서 알림을 허용해주세요.'
                : '투표 마감, 정산 요청, 일정 리마인드'}
          </span>
        </span>
        {isGranted ? (
          <span className="relative h-6 w-[42px] rounded-full bg-primary" aria-label="푸시 알림 켜짐">
            <span className="absolute right-[3px] top-[3px] h-[18px] w-[18px] rounded-full bg-white" />
          </span>
        ) : isDenied ? (
          <span className="rounded-full bg-warning-soft px-2 py-1 text-[10px] font-medium text-warning-strong">차단됨</span>
        ) : (
          <span className="relative h-6 w-[42px] rounded-full bg-surface-muted" aria-label="푸시 알림 꺼짐">
            <span className="absolute left-[3px] top-[3px] h-[18px] w-[18px] rounded-full bg-white" />
          </span>
        )}
      </div>
      {permission === 'default' && (
        <div className="border-t border-surface-border px-3.5 py-3">
          <Button
            variant="primary"
            onClick={() => void enablePush()}
            disabled={isRegistering}
            className="w-full"
          >
            {isRegistering ? '설정 중…' : '알림 받기'}
          </Button>
        </div>
      )}
      </div>
    </section>
  );
}
